// Asset Inspection API service
import { fetchWithAuth, getCSRFToken } from "../auth";

const API_HOST = process.env.REACT_APP_ICC_TOOL_API_HOST;

export async function getTeamAssets(teamIds) {
    let tempAssets = [];
    for (let i in teamIds) {
        const resp = await fetchWithAuth(`${API_HOST}teams/${teamIds[i]}/assets/`, {
            method: 'GET',
            headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
            credentials: 'include'
        });
        if (!resp.ok) throw new Error("Failed to fetch team assets");
        let respJson = await resp.json();
        tempAssets = tempAssets.concat(respJson);
    }
    return tempAssets;
}

export async function getPendingAssetInspections(assetId) {
    const resp = await fetchWithAuth(`${API_HOST}assets/${assetId}/has-pending-inspection/`, {
        method: 'GET',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error("Error fetching pending asset inspection info.");
    return await resp.json();
}

export async function getStanddownInspectionFields(assetId) {
    const resp = await fetchWithAuth(`${API_HOST}assets/${assetId}/standdown-inspection-fields/`, {
        method: 'GET',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error("Error fetching standdown inspection fields.");
    return await resp.json();
}

export async function getAssetInspectionDetail(id) {
    const resp = await fetchWithAuth(`${API_HOST}assetinspections/${id}/`, {
        method: 'GET',
        headers: { 'X-CSRFToken': getCSRFToken(), 'Content-Type': 'application/json' },
        credentials: 'include'
    });
    if (!resp.ok) throw new Error("Error fetching asset inspection details.");
    return await resp.json();
}

export async function getAssetInspectionTeam(assetId) {
    const resp = await fetchWithAuth(`${API_HOST}assets/${assetId}/`);
    if (!resp.ok) throw new Error('Unable to verify the inspection team. Please try again.');
    const asset = await resp.json();
    return asset.associatedTeam || null;
}

export async function submitAssetInspection(formData, draft, id) {
    let endpoint = id ? `assetinspections/${id}/` : 'assetinspections/';
    let method = id ? 'PATCH' : 'POST';
    if (draft) {
        endpoint += '?draft=1'
    }
    const resp = await fetchWithAuth(`${API_HOST}${endpoint}`, {
        method,
        headers: { 'X-CSRFToken': getCSRFToken() },
        body: formData
    });
    if (!resp.ok) {
        if (resp.status === 403) throw new Error('You do not have permission to update this inspection.');
        const errors = await resp.json().catch(() => ({}));
        throw new Error(Object.values(errors).flat().join(' ') || 'Failed to Create/Update asset inspection.');
    }
    return resp;
}